import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';
import {Table} from '../../../components/table/table.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {__} from '../../../support/lang/translations.ts';
import {formatKm} from '../../../support/format_distance.ts';
import {formatEuro} from '../../../support/format_currency.ts';
import {ReactElement} from 'react';
import {Identifier} from '../../../components/identifier/identifier.tsx';

interface OwnProps {
    occasion: OccasionType;
}

export function General({occasion}: OwnProps) {
    let taxDeductible: string | ReactElement = __('general.unknown');

    if (occasion.price && occasion.price > 1) {
        taxDeductible = occasion.price > 1 ? __('general.unknown') : __('general.non_applicable');
        if (occasion.tax === 'BTW_EX') {
            taxDeductible = __('general.yes');
        }

        if (occasion.tax === 'BTW_IN') {
            taxDeductible = __('general.no');
        }
    }

    return (
        <div>
            <div className={styles.tabs_grid}>
                <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.license_plate')}
                            value={<Identifier identifier={occasion.numberplate ?? ''} />}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.mileage')}
                            value={formatKm(occasion.mileage ?? 0)}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.build_year')}
                            value={occasion.build_year}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell name={__('occasions.details.general_fields.color')} value={occasion.color} />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.transmission')}
                            value={occasion.transmission}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell name={__('occasions.details.general_fields.bodywork')} value={occasion.bodywork} />
                    </TableRow>
                    {occasion.road_tax_min && occasion.road_tax_max ? (
                        <TableRow columns={1}>
                            <TableCell
                                name={__('occasions.details.general_fields.road_tax')}
                                value={`${formatEuro(occasion.road_tax_min)} ${__('general.till')} ${formatEuro(occasion.road_tax_max)}`}
                            />
                        </TableRow>
                    ) : null}
                </Table>
                <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                    <TableRow columns={1}>
                        <TableCell name={__('occasions.details.general_fields.fuel')} value={occasion.fuel} />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell name={__('occasions.details.general_fields.tax_deductible')} value={taxDeductible} />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.date_first_issue')}
                            value={occasion.date_first_issue}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.date_first_admission')}
                            value={occasion.date_first_admission}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.number_of_seats')}
                            value={occasion.number_of_seats}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell name={__('occasions.details.general_fields.doors')} value={occasion.doors} />
                    </TableRow>
                </Table>
            </div>
        </div>
    );
}
